export default function CopyIcon({ color = '#fff' }) {
  return (

    <svg width="2.4rem" height="2.4rem" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 14V7C4 5.9 4.9 5 6 5H13" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M17 20H10C8.9 20 8 19.1 8 18V11C8 9.9 8.9 9 10 9H17C18.1 9 19 9.9 19 11V18C19 19.1 18.1 20 17 20Z" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  )
}